import { lazy } from "react";
import { marketingAdministratorRoles } from "../../config/roles";
import { PageAction } from "../recordDefinition.types";

// Lazy, as the other pages' are, so each modal loads only when it is opened.
const AudienceExportModal = lazy(() => import("./actions/AudienceExportModal"));
const AudienceExportsModal = lazy(() => import("./actions/AudienceExportsModal"));
const AudienceCopyModal = lazy(() => import("./actions/AudienceCopyModal"));
const AudienceStatusModal = lazy(() => import("./actions/AudienceStatusModal"));

export const communicationAudiencePageActions: PageAction[] = [
  {
    id: "export",
    label: "Export",
    roles: marketingAdministratorRoles,
    visible: (record) => Boolean(record.id),
    modal: AudienceExportModal,
  },
  {
    id: "exports",
    label: "Exports",
    roles: marketingAdministratorRoles,
    visible: (record) => Boolean(record.id),
    modal: AudienceExportsModal,
  },
  {
    id: "copy",
    label: "Copy Audience",
    roles: marketingAdministratorRoles,
    modal: AudienceCopyModal,
  },
  {
    id: "set-status",
    label: (record) =>
      record.statecode === 0 ? "Deactivate Audience" : "Activate Audience",
    roles: marketingAdministratorRoles,
    modal: AudienceStatusModal,
  },
];
